import { UploadFiles } from '@dealstack/frontend/shared/components/UploadFiles/UploadFiles';
import { useUploadFiles } from '@dealstack/frontend/shared/components/UploadFiles/useUploadFiles';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

interface Props {
	onUpload: (files: File[]) => Promise<void>;
	onTemplateDownload: () => void;
}

export const UploadFile = ({ onUpload, onTemplateDownload }: Props) => {
	const commonUiTranslation = useTranslationCommonUi();

	const { acceptedFileTypes, onDrop } = useUploadFiles({
		acceptedFileTypes: ['xls', 'xlsx'],
		onError: () => {
			showToastV2({
				title: commonUiTranslation('investors.error.upload'),
				state: 'error',
			});
		},
		singleFile: true,
		onFilesUploaded: onUpload,
	});

	return (
		<div className="flex justify-around mt-12">
			<UploadFiles
				title={commonUiTranslation('investors.upload_file.title')}
				description={commonUiTranslation('investors.upload_file.description')}
				labelText={commonUiTranslation('investors.upload_file.label')}
				acceptedFileTypes={acceptedFileTypes}
				acceptedFilesText={commonUiTranslation('investors.upload_file.accepted_types')}
				singleFile
				onDrop={onDrop}
				additionalButtonText={commonUiTranslation('investors.download_file.label')}
				additionalButtonHandler={onTemplateDownload}
			/>
		</div>
	);
};
